<main class="min-h-screen bg-bg-base flex flex-col">
  <app-projects-header
    (search)="onSearch($event)"
    (clearSearch)="onClearSearch()"
  ></app-projects-header>
  
  <div class="flex-1">
    <app-projects-data></app-projects-data>
    <app-projects [searchQuery]="searchQuery" [searchVersion]="searchVersion"></app-projects>
    <app-you-developer></app-you-developer>
  </div>
</main>
